// カタログで扱う日付の文字列("YYYY-MM-DD")をパースして、年月日をnumberで返す関数
export function parseDate(dateString: string) {
  // 文字列をパースし、年、月、日をnumber型で配列に保存
  const splitted = dateString.split('-');
  if (splitted.length !== 3) {
    return undefined;
  }

  const formatted = splitted.map(numStr => parseInt(numStr, 10));
  if (formatted.includes(NaN)) {
    return undefined;
  }

  return new Date(formatted[0], formatted[1] - 1, formatted[2]);
}
